import parameters from '@atlassian/jira-relay/src/__generated__/uiVersionBacklogPanelRelayQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const versionsPanelEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "backlog-versions-panel-relay" */ './src'),
	),
	getPreloadProps: (variables: {
		after?: string | null;
		first: number;
		jiraProjectIds: Array<string>;
		cloudId: string;
		boardId: string;
		shouldShowVersionPanel: boolean;
	}) => ({
		queries: {
			versionsPanel: {
				options: {
					// have to add "as const" https://stackoverflow.com/questions/37978528/typescript-type-string-is-not-assignable-to-type
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables,
			},
		},
	}),
});
